import { render, staticRenderFns } from "./DashboardIsland.vue?vue&type=template&id=59a882c8&"
import script from "./DashboardIsland.vue?vue&type=script&lang=js&"
export * from "./DashboardIsland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports